module.exports = __webpack_public_path__ + "static/tcsScreenshot-54c3ba0e4c90aff9f18753846155ee69.png";